module.exports = __webpack_public_path__ + "img/class-virus.cfa36cd0.png";